import type { EngineSlot } from '@seen/request-types/schedulingRules'

export interface EngineSlotTiers {
  clean: EngineSlot[]
  warned: EngineSlot[]
}

// The engine returns warning-carrying candidates on purpose — they are
// offerable, just not clean — but the calendar shades those same warning
// intervals as hatched avoid bands. Listing both tiers undifferentiated puts
// suggestions visually on top of the hatch. Splitting mirrors /schedule's rail:
// clean answers lead, warned ones stay available behind a disclosure.
export function partitionEngineSlots(slots: EngineSlot[]): EngineSlotTiers {
  return {
    clean: slots.filter((slot) => slot.warnings.length === 0),
    warned: slots.filter((slot) => slot.warnings.length > 0),
  }
}

// The candidate set mirrored onto the calendar grid as dashed outlines. Warned
// slots only join once the operator has revealed them: an outline drawn over a
// hatched band otherwise reads as the engine contradicting its own shading.
export function gridMirroredSlots(
  slots: EngineSlot[],
  warnedRevealed: boolean
): { start: string; end: string }[] {
  const { clean, warned } = partitionEngineSlots(slots)
  return [...clean, ...(warnedRevealed ? warned : [])].map((slot) => ({
    start: slot.start,
    end: slot.end,
  }))
}
